import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en.json';
import translationSR from './locales/sr.json';
import translationSK from './locales/sk.json';
import translationDE from './locales/de.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  sr: {
    translation: translationSR
  },
  sk: {
    translation: translationSK
  },
  de: {
    translation: translationDE
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem('language') || 'sr', // default language is Serbian
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
